import Stripe from "stripe";

interface Props {
  price: number;
  location: string;
  coupon?: Stripe.Coupon | null;
}

const PriceComponent = ({ price, location, coupon }: Props) => {
  const currency = location === "India" ? <span>&#8377;</span> : <span>$</span>;
  if (!coupon) {
    return (
      <p className="text-xl pt-4">
        {currency}
        {"  "}
        <span className="text-4xl font-semibold">{price.toFixed()}</span>
      </p>
    );
  }

  const { percent_off, amount_off } = coupon;

  if (percent_off) {
    return (
      <div>
        <p className="text-xl pt-4 line-through">
          {currency}
          {"  "}
          <span className="font-semibold">{price.toFixed()}</span>
        </p>
        <p className="text-xl">
          {currency}
          {"  "}
          <span className="text-4xl font-semibold">
            {((price * (100 - percent_off)) / 100).toFixed()}
          </span>
        </p>
      </div>
    );
  }

  if (amount_off) {
    return (
      <div>
        <p className="text-xl pt-4 line-through">
          {currency}
          {"  "}
          <span className="font-semibold">{price.toFixed()}</span>
        </p>
        <p className="text-xl">
          {currency}
          {"  "}
          <span className="text-4xl font-semibold">
            {(price - amount_off).toFixed()}
          </span>
        </p>
      </div>
    );
  }

  return (
    <p className="text-xl pt-4">
      {currency}
      {"  "}
      <span className="text-4xl font-semibold">{price.toFixed()}</span>
    </p>
  );
};

export default PriceComponent;
